import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { NgxStarRatingModule } from 'ngx-star-rating';
import { ShowServicesDialogComponent } from '../patients/doctor-profile/components/show-services-dialog/show-services-dialog.component';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [SearchComponent,ShowServicesDialogComponent],
  imports: [
    CommonModule,
    SearchRoutingModule,
    MatDialogModule,
    // NgxStarRatingModule,
    FormsModule,
    MatButtonModule,
    SharedModule,
    NgbModule,
    NgSelectModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
  ]
})
export class SearchModule { }
